import React from 'react';
import PropTypes from 'prop-types';

import { ToolbarButton } from './ToolbarButton';

const AnswerButton = ({ onAnswerClick }) => (
  <ToolbarButton onClick={onAnswerClick}>
    Répondre
  </ToolbarButton>
);

AnswerButton.propTypes = {
  onAnswerClick: PropTypes.func.isRequired,
};

export { AnswerButton };
